// LOGIN
import { LoginState } from './login/login.state';
import { LoginReducer } from './login/login.reducer';
import { LoginEffects } from './login/login.effects';
// REMEMBER
import { RememberPassState } from './rememberPass/rememberPass.state';
import { RememberPassReducer } from './rememberPass/rememberPass.reducer';
import { RememberPassEffects } from './rememberPass/rememberPass.effects';
// RESET
import { ResetPassState } from './resetPass/resetPass.state';
import { ResetPassReducer } from './resetPass/resetPass.reducer';
import { ResetPassEffects } from './resetPass/resetPass.effects';
// NGRX
import { combineReducers } from '@ngrx/store';
import { SignupState } from './signup/signup.state';
import { SignupEffects } from './signup/signup.effects';

export interface AccessSate {
    login: LoginState;
    rememberPass: RememberPassState;
    resetPass: ResetPassState;
    signup: SignupState;
}

export const accessEffects = [
    LoginEffects,
    RememberPassEffects,
    ResetPassEffects,
    SignupEffects
];

// export const accessReducers = combineReducers({
//     login: LoginReducer,
//     rememberPass: RememberPassReducer,
//     resetPass: ResetPassReducer
// });

